import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

export type WorkflowRunStatusFiltersFetchedPayload = LabeledValuePayload[];

export type WorkflowRunStatusFiltersFetchedAction = {
	type: 'WORKFLOW_RUN_STATUS_FILTERS_FETCHED';
	payload: WorkflowRunStatusFiltersFetchedPayload;
};

export default (payload: WorkflowRunStatusFiltersFetchedPayload): WorkflowRunStatusFiltersFetchedAction => ({
	type: 'WORKFLOW_RUN_STATUS_FILTERS_FETCHED',
	payload,
});
